import React, { FC, useEffect, useState } from "react";
import { Menu as AntMenu } from "antd";
import { Badge } from "../../atoms/Badge";
import {
  Wrapper,
  Menu,
  MobileViewHeader,
  BurgerWrapper,
  Logo,
  PcViewHeader,
  Logo2,
  CommonMenuWrapper,
  MenuCloseBtn,
} from "./elements";
import { MenuOutlined } from "@ant-design/icons";
import logo from "../../../assets/images/new_logo_white.svg";
import {
  bell,
  calendarFilled,
  logout,
  project,
  recruitment,
  settings,
  menuClose,
  myAccount,
} from "../../../assets/icons/index";
import { useMediaQuery } from "../../../hooks/common";
import { theme } from "../../../config";
import { DownloadOutlined } from "@ant-design/icons";
import { onMessageListener } from "../../../firebase";
const { SubMenu } = AntMenu;

type Props = {
  handleClick?: (e: any) => void | (() => void);
  showHideSidenav: string;
  toggleSideNav: () => void;
  defaultSelectedKey?: string;
  user?: any;
  currentSubmenu?: string;
  notificationCount?: number;
};

const Sidebar: FC<Props> = (props) => {
  const {
    handleClick,
    showHideSidenav,
    toggleSideNav,
    defaultSelectedKey,
    user,
    currentSubmenu,
    notificationCount
  } = props;

  const isTabletOrMobile = useMediaQuery(theme.breakpoints.mobileAndTablet);

  const userAccessType = user && user.accessType;

  const phases = [
    { key: "/recruit/search-applicants", name: "Search Applicants" },
    { key: "/recruit/new-applicants", name: "New Applicants" },
    { key: "/recruit/shortlisted", name: "Shortlisted" },
    { key: "/recruit/technical-exam", name: "Technical Exam" },
    { key: "/recruit/initial-interview", name: "Initial Interview" },
    { key: "/recruit/psychological-exam", name: "Psychological Exam" },
    { key: "/recruit/final-interview", name: "Final Interview" },
    { key: "/recruit/job-offer", name: "Job Offer" },
    { key: "/recruit/failed", name: "Failed" },
  ];

  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(notificationCount || 0);
    if (onMessageListener) {
      onMessageListener().then((v) => setCount(() => notificationCount ? notificationCount + 1 : count))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationCount])

  const locationHas = (pathname: string) =>
    defaultSelectedKey?.includes(pathname);

  const highlightedKey = () =>
    locationHas(`${phases[0].key}/`)
      ? phases[0].key
      : locationHas(`${phases[1].key}/`)
        ? phases[1].key
        : locationHas(`${phases[2].key}/`)
          ? phases[2].key
          : locationHas(`${phases[3].key}/`)
            ? phases[3].key
            : locationHas(`${phases[4].key}/`)
              ? phases[4].key
              : locationHas(`${phases[5].key}/`)
                ? phases[5].key
                : locationHas(`${phases[6].key}/`)
                  ? phases[6].key
                  : locationHas(`${phases[7].key}/`)
                    ? phases[7].key
                    : locationHas(`${phases[8].key}/`)
                      ? phases[8].key
                      : locationHas(`/recruit/my-account/`)
                        ? "/recruit/my-account"
                        : locationHas("/admin/users/")
                          ? "/admin/users"
                          : locationHas("/admin/positions/")
                            ? "/admin/positions"
                            : defaultSelectedKey;

  const recruitmentPhases = () => {
    if (userAccessType === "interviewer") {
      return phases.map(
        (phase) =>
          (phase.name === "Initial Interview" ||
            phase.name === "Final Interview") && (
            <Menu.Item key={phase.key}>{phase.name}</Menu.Item>
          )
      );
    }
    return phases.map((phase) => (
      <Menu.Item key={phase.key}>{phase.name}</Menu.Item>
    ));
  };

  const handleMobileHeaderToggle = showHideSidenav === 'show' ? toggleSideNav : () => { };

  return (
    <>
      <MobileViewHeader onClick={handleMobileHeaderToggle}>
        <BurgerWrapper>
          <MenuOutlined onClick={toggleSideNav} />
        </BurgerWrapper>
        <Logo src={logo} alt="logo" />
      </MobileViewHeader>
      <Wrapper
        className={showHideSidenav}
        isInterviewer={userAccessType === "interviewer"}
      >
        <Menu
          onClick={handleClick}
          defaultSelectedKeys={
            userAccessType === "interviewer"
              ? ["/recruit/initial-interview"]
              : [highlightedKey() || ""]
          }
          selectedKeys={[highlightedKey() || ""]}
          defaultOpenKeys={[currentSubmenu ? currentSubmenu : "Recruitment"]}
          mode="inline"
          theme="dark"
        >
          <PcViewHeader>
            <Logo2 src={logo} alt="logo" />
            {isTabletOrMobile && (
              <MenuCloseBtn onClick={toggleSideNav}>
                <img src={menuClose} alt="menu-close" />
              </MenuCloseBtn>
            )}
          </PcViewHeader>
          {userAccessType !== "interviewer" && (
            <>
              <Menu.Item
                key="/recruit/insights"
                icon={<img src={project} alt="project icon" />}
              >
                Insights
              </Menu.Item>
              <Menu.Item
                key="/recruit/applicants-database"
                icon={<DownloadOutlined />}
              >
                Applicants Database
              </Menu.Item>
              <Menu.Item
                key="/recruit/my-schedule"
                icon={<img src={calendarFilled} alt="calendar icon" />}
              >
                My Schedule
              </Menu.Item>
              <Menu.Item
                key="/admin/notifications"
                icon={<img src={bell} alt="bell icon" />}
              >
                Notifications &nbsp;
                <Badge count={count || 0} />
              </Menu.Item>
            </>
          )}
          <SubMenu
            key="Recruitment"
            icon={<img src={recruitment} alt="recruitment icon" />}
            title="Recruitment"
          >
            {recruitmentPhases()}
          </SubMenu>
          <CommonMenuWrapper $isInterviewer={userAccessType === "interviewer"}>
            {user && (user.isAdmin || user.isSuperAdmin || userAccessType === 'recruiter') ? (
              <SubMenu
                key="Settings"
                icon={<img src={settings} alt="settings icon" />}
                title="Settings"
              >
                {(user.isAdmin || user.isSuperAdmin) && <Menu.Item key="/admin/users">Users</Menu.Item>}
                <Menu.Item key="/admin/positions">Positions</Menu.Item>
              </SubMenu>
            ) : (
              <Menu.Item
                key="/recruit/my-account"
                icon={<img src={settings} alt="settings icon" />}
              >
                My Account
              </Menu.Item>
            )}
            { user && (user.isSuperAdmin || userAccessType === 'recruiter') && (
              <Menu.Item
                key="/recruit/my-account"
                icon={<img src={myAccount} alt="settings icon" />}
              >
                My Account
              </Menu.Item>
            )}
            <Menu.Item
              key="/recruit/logout"
              icon={<img src={logout} alt="logout icon" />}
            >
              Logout
            </Menu.Item>
          </CommonMenuWrapper>
        </Menu>
      </Wrapper>
    </>
  );
};

export default Sidebar;
